import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=6b738439&"
import script from "./setup.js?vue&type=script&lang=javascript&"
export * from "./setup.js?vue&type=script&lang=javascript&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports